/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFillFileCsv = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M11.313 11.903h-1.277c-.624 0-1.11.123-1.458.369-.336.246-.504.596-.504 1.05 0 .419.108.745.324.978.228.234.558.35.99.35.3 0 .582-.055.846-.166.264-.122.498-.288.702-.497.144-.149.27-.314.377-.496z" />
        <path d="M2 2.5h20v19H2zm13.968 13.976h1.059l-1.22 3.024h1.367l1.782-3.043v-2.673h-2.988zm-3.916 0h1.781V9.893c0-1.094-.33-1.93-.99-2.508-.647-.59-1.595-.885-2.843-.885-.66 0-1.314.068-1.962.203a8.778 8.778 0 0 0-1.674.516v2.12a9.448 9.448 0 0 1 1.692-.516 7.387 7.387 0 0 1 1.566-.184c.564 0 .978.08 1.242.24.264.16.396.51.396 1.05v.351H9.694c-.852 0-1.596.135-2.232.406-.624.27-1.11.651-1.458 1.143-.336.492-.504 1.076-.504 1.752 0 .971.282 1.733.846 2.286.576.554 1.356.83 2.34.83.768 0 1.452-.203 2.052-.608.387-.262.707-.588.959-.978z" />
      </g>
    </g>
  </Icon>
);
export { SvgFillFileCsv as FillFileCsv };
